export interface AppError {
  message: string;
  code?: number | string;
}

export const extractErrorMessage = (error: any): string =>
  typeof error === "string"
    ? error
    : error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message;

export const extractError = (error: any): AppError => ({
  code: error?.response?.status,
  message: extractErrorMessage(error)
});
